import { render, staticRenderFns } from "./CardTaxInvoiceInfoOrder.vue?vue&type=template&id=71c64393&"
import script from "./CardTaxInvoiceInfoOrder.vue?vue&type=script&lang=js&"
export * from "./CardTaxInvoiceInfoOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports